<template>
  <div ref="root" class="jps-quill-editor" />
</template>

<script lang="ts" setup>
//TODO 英語対応 元からあるTODO
const tooltips = {
  '.ql-bold': { ja: '太字' },
  '.ql-italic': { ja: '斜体' },
  '.ql-underline': { ja: '下線' },
  '.ql-strike': { ja: '取り消し線' },
  '.ql-script[value="sub"]': { ja: '下付き' },
  '.ql-script[value="super"]': { ja: '上付き' },
  'span.ql-color': { ja: '文字色' },
  'span.ql-background': { ja: '背景色' },
  '.ql-link': { ja: 'ハイパーリンク' },
  '.ql-blockquote': { ja: '引用' },
  '.ql-code-block': { ja: 'コード' },
  '.ql-list[value="ordered"]': { ja: '順序付きリスト' },
  '.ql-list[value="bullet"]': { ja: '順序なしリスト' },
  '.ql-align': { ja: '文字揃え' },
  '.ql-indent[value="-1"]': { ja: 'インデントを減らす' },
  '.ql-indent[value="+1"]': { ja: 'インデントを増やす' },
  '.ql-clean': { ja: '書式のクリア' },
}

const colors = [
  '#1a1a1a',
  '#fbfbfb',
  '#d30c2f',
  '#15d197',
  '#196ac9',
  '#d1c115',
  '#610e95',
  '#fe8900',
  '#5b4b73',
  '#734b52',
  '#736f4b',
  '#294039',
  '#ff6827',
  '#4b5d73',
  '#2b2b2b',
  '#414141',
  '#646464',
  '#979797',
  '#d9d9d9',
  '#ededed',
  '#f5f5f5',
]

const { ls, lss } = useI18n()
const { $createQuill } = useNuxtApp()

interface Props {
  placeholder: string
}
const props = withDefaults(defineProps<Props>(), {})
const emits = defineEmits(['input'])

let quill = null
const setContents = (n: Delta) => {
  if (import.meta.client) {
    if (!quill) {
      init()
    }
    quill.setContents(n)
  }
}
defineExpose({ setContents })

const root = ref<HTMLElement>(null)
const init = () => {
  let container = root.value
  let options = {
    modules: {
      toolbar: [
        [
          'bold',
          'italic',
          'underline',
          'strike',
          { script: 'sub' },
          { script: 'super' },
        ],
        [
          {
            color: colors,
          },
          { background: colors },
        ],
        ['link'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['clean'],
      ],
    },
    bounds: container,
    placeholder: props.placeholder,
    formats: [
      'background',
      'color',
      'bold',
      'italic',
      'strike',
      'script',
      'underline',
      'list',
      'blockquote',
      'indent',
      'align',
      'code-block',
      'link',
    ],
    theme: 'bubble',
  }
  quill = $createQuill(container, options)
  quill.on('text-change', (delta, oldDelta, source) => {
    if (source === 'user') {
      const content: Delta = quill.getContents()
      content.ops.forEach((op) => {
        if (op && typeof op.insert !== 'string') op.insert = ''
      })
      emits('input', quill.getContents())
    }
  })
  container.addEventListener('click', (evt: MouseEvent) => {
    let path = evt.composedPath()
    for (let i = 0; i < path.length; i++) {
      if (path[i]['href']) {
        window.open(path[i]['href'])
      }
    }
  })
  nextTick(() => {
    //ツールチップの付与
    Object.keys(tooltips).forEach((query) => {
      container
        .querySelector(query)
        .setAttribute('title', ls(tooltips[query]))
    })
    //Placeholderの上書き
    container
      .querySelector('[data-link]')
      .setAttribute(
        'data-link',
        lss(
          'URLを入力してEnterを押して下さい',
          'Input URL and press Enter to confirm'
        )
      )
  })
}
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.jps-quill-editor {
  .ql-editor {
    a {
      &::before {
        display: none;
      }
      &::after {
        display: none;
      }
    }
  }
  .ql-toolbar .ql-active .ql-stroke {
    stroke: $jps-key-red !important;
  }
  .ql-tooltip-editor {
    input::placeholder {
    }
  }
}
</style>
